import React from 'react';
import './PowerTypeModal.scss';

class PowerTypeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPowerType: { id: this.props.selectedPowerTypeTab },
    };
    this.disable = !this.props.selectedPowerTypeTab;
    this.submitBtn = 'Select Power Type';
  }

  changePowerType(ev, type) {
    const { displayRedirectPopup, studioEnable, redisCommonData } = this.props;
    if (type.id === 'frame_only') {
      this.submitBtn = 'Add To Cart';
    } else if (type.id === 'bifocal' && studioEnable) {
      if (redisCommonData?.STUDIO_FLOW_WEB) {
        this.submitBtn = 'Add To Cart';
      } else {
        displayRedirectPopup();
        return;
      }
    } else {
      this.submitBtn = 'Select Power Type';
    }
    this.setState({ selectedPowerType: type });
    if (this.disable) {
      this.disable = false;
    }
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.Pdp.click.newGa('lensDescription', { powerType: type.id });
    const { setPowerType } = this.props;
    setPowerType(ev, type);
  }

  arrangeString(value) {
    return value.split('<br>').join(' ');
  }

  render() {
    const { productData, redisCommonData } = this.props;
    const { selectedPowerType } = this.state;
    const { lensPackageTextConfig } = redisCommonData;
    const packageTextConfig = lensPackageTextConfig && JSON.parse(lensPackageTextConfig);

    return (
      <div className="h-100vh-less150 overflow-y-auto margin-t150">
        <div className="extra-div">
          <div className="select-power-type-section w-80 padding-t30 padding-b40 cursor-pointer margin-0-auto">
            {productData.prescriptionType.map(powerType => {
              const packageDesc = this.arrangeString(packageTextConfig[powerType.id].subtitle);
              return (
                <div
                  key={powerType.id}
                  className={`${
                    selectedPowerType.id === powerType.id ? 'border-topaz' : 'border-gray'
                  } bora-9 padding-t10 padding-b10 padding-l20 padding-r20 margin-b20`}
                  onClick={ev => this.changePowerType(ev, powerType)}
                >
                  <div className="display-flex align-items-center justify-content-between">
                    <div className="display-flex align-items-center">
                      <img
                        alt={powerType.id}
                        className="padding-r25"
                        src={`https://static.lenskart.com/media/desktop/img/pdp/${powerType.id}.png`}
                      />
                      <div>
                        <div className="fs16 fw600">{powerType.title}</div>
                        <div
                          dangerouslySetInnerHTML={{ __html: packageDesc }}
                          className="fs13 power-type-desp padding-t5"
                        ></div>
                      </div>
                    </div>
                    <img
                      alt="check"
                      className="cursor-pointer"
                      src={` ${
                        selectedPowerType.id === powerType.id
                          ? 'https://static.lenskart.com/media/desktop/img/pdp/check_enabled.png'
                          : 'https://static.lenskart.com/media/desktop/img/pdp/check_disabled.png'
                      }`}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default PowerTypeModal;
